/** Client-side aggregation from per-cohort day_wise_data (replaces aggregate.offer_categories / aggregate.survey). */

export const surveyOfCohortD0 = (cohort) => {
	const dw = cohort?.day_wise_data ?? [];
	const d0 = dw.find((d) => String(d.day) === "D0") ?? dw[0];
	return d0?.survey ?? null;
};

export const aggregateOfferCategoriesFromCohorts = (cohorts, day = "D0") => {
	const list = cohorts ?? [];
	const n = list.length || 1;
	const catMap = {};

	list.forEach((c) => {
		const entry = (c?.day_wise_data ?? []).find((d) => String(d.day) === String(day));
		(entry?.offers?.categories ?? []).forEach((cat) => {
			const key = cat.category ?? "Unknown";
			if (!catMap[key]) {
				catMap[key] = { category: key, total_clicks: 0, completed_clicks: 0, users: 0 };
			}
			catMap[key].total_clicks += cat.total_clicks || 0;
			catMap[key].completed_clicks += cat.completed_clicks || 0;
			catMap[key].users += cat.users || 0;
		});
	});

	return Object.values(catMap).map((c) => ({
		category: c.category,
		avg_clicks: Math.round(c.total_clicks / n),
		avg_completed: Math.round(c.completed_clicks / n),
		avg_users: Math.round(c.users / n),
	}));
};

export const aggregateSurveyFromCohorts = (cohorts) => {
	const list = cohorts ?? [];
	const n = list.length || 1;

	let reg = { attempted: 0, completed: 0 };
	let partner = { attempted: 0, completed: 0 };
	let other = { attempted: 0, completed: 0 };

	list.forEach((c) => {
		const s = surveyOfCohortD0(c);
		reg.attempted += s?.registration_profiler?.attempted || 0;
		reg.completed += s?.registration_profiler?.completed || 0;
		partner.attempted += s?.partner_survey?.attempted || 0;
		partner.completed += s?.partner_survey?.completed || 0;
		Object.values(s?.other_profiler ?? {}).forEach((o) => {
			other.attempted += o?.attempted || 0;
			other.completed += o?.completed || 0;
		});
	});

	const mk = (totals) => ({
		avg_attempted: Math.round(totals.attempted / n),
		avg_completed: Math.round(totals.completed / n),
		avg_completion_rate:
			totals.attempted > 0 ? ((totals.completed / totals.attempted) * 100).toFixed(1) : "0.0",
	});

	return {
		registration_profiler: mk(reg),
		partner_survey: mk(partner),
		other_profiler: mk(other),
	};
};
